<template>
  <InputComponent v-bind="$attrs">
    <RichTextComponent v-model="comp" :disabled="$attrs.disabled" />
  </InputComponent>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import RichTextComponent from '@kvass/rich-text'

import { ValueComp } from '../utils'

export default {
  props: ['value'],
  computed: {
    comp: ValueComp(),
  },
  components: {
    InputComponent,
    RichTextComponent,
  },
}
</script>
